import {lazyInitialize, nonenumerable} from 'core-decorators';
import APIRequestState from './_util/api-request';
import QS from 'qs';

class GetAvailableWorkers extends APIRequestState {
  getRequest(urlParams) {
    return this.ctx.sdk.get(`/service-available-workers?${QS.stringify(urlParams)}`);
  }
}
class GetWorkerSummaries extends APIRequestState {
  getRequest(worker_ids, urlParams) {
    return this.ctx.sdk.get(`/workers/summaries?${QS.stringify({worker_ids, ...urlParams})}`);
  }
}

class GetWorkerProfile extends APIRequestState {
  getRequest(worker_id, urlParams) {
    return this.ctx.sdk.get(`/workers/${worker_id}/?${QS.stringify({lastBooked: true, withPortfolio: true, ...urlParams})}`);
  }
}

class GetWorkerLanguages extends APIRequestState {
  getRequest(worker_id, urlParams) {
    return this.ctx.sdk.get(`/workers/${worker_id}/languages?${QS.stringify({...urlParams})}`);
  }
}

class GetWorkerPromotedReviews extends APIRequestState {
  getRequest(worker_id, urlParams) {
    return this.ctx.sdk.get(`/workers/${worker_id}/reviews/promoted?${QS.stringify({...urlParams})}`);
  }
}

class GetWorkerReviews extends APIRequestState {
  getRequest(worker_id, urlParams) {
    return this.ctx.sdk.get(`/workers/${worker_id}/reviews?${QS.stringify({id: worker_id, ...urlParams})}`);
  }
}

class WorkersStateV2 {
  @lazyInitialize @nonenumerable getServiceAvailableWorkers = new GetAvailableWorkers(this.ctx);
  @lazyInitialize @nonenumerable getWorkerLanguages = new GetWorkerLanguages(this.ctx);
  @lazyInitialize @nonenumerable getWorkerProfile = new GetWorkerProfile(this.ctx);
  @lazyInitialize @nonenumerable getWorkerPromotedReviews = new GetWorkerPromotedReviews(this.ctx);
  @lazyInitialize @nonenumerable getWorkerReviews = new GetWorkerReviews(this.ctx);
  @lazyInitialize @nonenumerable getWorkerSummaries = new GetWorkerSummaries(this.ctx);

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }

  dispose() {}
}

export default WorkersStateV2;



// WEBPACK FOOTER //
// ./spa/state/workers-v2.jsx